import ccpAgentMiddleware from './ccp.agent'
import ccpInitMiddleware from './ccp.app'
import ccpContactMiddleware from './ccp.contact'

const ccp = [ccpInitMiddleware, ccpAgentMiddleware, ccpContactMiddleware]

export default ccp
